import {SignUpComponent} from "../SignUpComponent.js";

export class EmailButton extends SignUpComponent {

    template() {
        const {id = '', buttonText = '' } = this.$props;
        return `<a id = "${Mutil.n2v(id)}" class="js-email-button next-page-link" ><i class="icon-next-link"></i>${Mutil.n2v(buttonText)}</a>`
    }

    setEvent() {
        const { clickFunc = Mutil.noop } = this.$props;
        super.setEvent();
        this.addEvent("click.prevent", `.js-email-button`, (e) => {
            if(typeof clickFunc === "function") {
                clickFunc();
            }
        });
    }

};

